import React from "react";
import PageLayout from "../../components/PageLayout/PageLayout";

export default function ImpressumPage(props) {
  const { configuration } = props;

  return (
    <PageLayout configuration={configuration} title="Impressum">
      <section className="spg-section">
        <div className="spg-kicker">Rechtliches</div>
        <h2 className="spg-title">Impressum</h2>
        <div className="spg-legal" dangerouslySetInnerHTML={{ __html: configuration.impressumText || '' }} />
      </section>
    </PageLayout>
  );
}
